import React, { useState } from "react";
import HeroBanner from "../../../assets/svgs/employer_login_hero.png";
import NeoInsuranceLogo from "../../../assets/svgs/neoInsuranceLogoWhite_risk.svg";
import doubleCircle from "../../../assets/svgs/doupleCircle.svg";
import quote from "../../../assets/svgs/quote.svg";
import dotted from "../../../assets/svgs/dotted.svg";
import Building from "../../../assets/images/building.jpeg";
import { env } from "../../../config.json";
import { LargeButton } from "../../../components";
import { Ptag } from "../../../components/fonts";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Error,
  LoginContentWrapper,
  LoginPageWrapper,
  OverlayTint,
  PhoneInput,
  PhoneInputWrapper,
  SideImage,
} from "./styles";
import http from "../../../services/httpService";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const ResetPassword = () => {
  const { state } = useParams();
  const [resetValue, setResetValue] = useState("");
  const [password, setPassword] = useState("");
  const [lading, setLoading] = useState("");
  const [email, setEmail] = useState("");
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [error, setError] = useState("");
  const [sncakValue, setSnackValue] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const history = useHistory();
  console.log(history.location.state, "i am here at the end");
  const passwordValidator = (event) => {
    setPassword(event.target.value);
  };

  const passwordValidator2 = (event) => {
    setResetValue(event.target.value);
  };
  const loginHandler = async () => {
    const state = history.location.state;
    const hasError = checkError();
    if (hasError) return;
    if (password !== resetValue) {
      setErrorSnackbar(true);
      setSnackValue("Confirmed Password should match with New Password.");
      return;
    }
    try {
      let action;
      if (localStorage.getItem("navigatingFrom") === "login") {
        action = "LOGIN";
      } else {
        action = "REGISTER";
      }

      let { data } = await http.post("/phone/update_employer_password/", {
        email: state.email,
        password: password,
      });
      data = data.data;
      const about = {
        name: data["company"] && data["company"]["company_name"],
        pincode: data["company"] && data["company"]["pincode"],
        numberOfEmployees:
          data["company"] && data["company"]["number_of_employees"],
        email: data["email"],
      };
      localStorage.setItem("uuid", data.id);
      const options = ["GMC", "GMC_M", "GPA", "GTL"];
      if (data.company.flex) {
        console.log("IN");
        localStorage.setItem("isFlex", true);
      } else if (options.includes(data.b_type)) {
        localStorage.setItem("flow", data.b_type);
      }
      localStorage.setItem("about", JSON.stringify(about));
      localStorage.removeItem("navigatingFrom");
      localStorage.setItem("marketplace_city", data["marketplace_city"]);
      localStorage.setItem("businessAccount", true);
      localStorage.setItem(
        "companyId",
        data["company"] && data["company"]["id"]
      );
      const loggingInFor = localStorage.getItem("logginginfor");
      if (data["company"] && data["company"]["userplan_id"]) {
        localStorage.setItem("userplan_id", data["company"]["userplan_id"]);
        localStorage.setItem("token", data.token);
        if (loggingInFor === "insurancepayment") {
          history.push("/business/payment");
          return;
        }
        history.push("/business/dashboard");
      } else if (
        data["company"] &&
        !data["company"]["userplan_id"] &&
        data["company"]["employee_collection_required"]
      ) {
        localStorage.setItem("token", data.token);
        history.push("/business/employee-registration-dashboard");
      } else {
        setLoading(false);
      }
    } catch (ex) {
      setLoading(false);
      console.log(ex);
      if (ex.response && ex.response.status === 400) setLoading(false);

      // this.setState({ error: ex.response && ex.response.data });
    }
  };

  const setupLocalStorage = () => {
    localStorage.setItem("navigatingFrom", "login");
    // localStorage.setItem("email", email);
  };
  const checkError = () => {
    if (!password) {
      setError("*Required");
    } else {
      setError("");
    }
    if (!resetValue) {
      setPasswordError("*Required");
    } else {
      setPasswordError("");
    }
    if (!password || !resetValue) {
      return true;
    } else {
      return false;
    }
  };
  const removeError = () => {
    setError("");
  };
  console.log(error);
  const useStyles = makeStyles({
    cookieAlert: {
      "& .MuiAlert-message": {
        fontSize: "14px",
      },
    },
  });

  const classes = useStyles();

  return (
    <>
      <Snackbar
        open={errorSnackbar}
        autoHideDuration={4000}
        onClose={() => setErrorSnackbar(false)}
      >
        <Alert severity="error" className={classes.cookieAlert}>
          {sncakValue}
        </Alert>
      </Snackbar>
      <LoginPageWrapper>
        <aside
          style={{
            position: "relative",
          }}
        >
          <img
            src={NeoInsuranceLogo}
            style={{
              position: "absolute",
              zIndex: "20",
              width: "50%",
              top: "60px",
              left: "40px",
              height: "auto",
            }}
          />
          <img
            src={dotted}
            style={{
              position: "absolute",
              zIndex: "20",
              height: "15%",
              width: "15%",
              opacity: "50%",
              top: "20%",
              left: "60%",
            }}
          />
          <img
            src={doubleCircle}
            style={{
              position: "absolute",
              zIndex: "20",
              height: "20%",
              opacity: "50%",
              width: "20%",
              bottom: "0px",
              left: "-2px",
            }}
          />
          <OverlayTint />
          <SideImage src={Building} />
        </aside>
        <LoginContentWrapper>
          <div>
            <Ptag fontSize="20px" fontWeight="700" marginTop="2em">
              Set Password
            </Ptag>
            <div
              style={{ display: "flex", gap: "2rem", flexDirection: "column" }}
            >
              <div>
                <Ptag
                  fontSize="18px"
                  fontWeight="700"
                  marginLeft="1rem"
                  marginBottom="1rem"
                >
                  New Password
                </Ptag>
                <PhoneInputWrapper>
                  <PhoneInput
                    type="password"
                    // value={password}
                    onChange={passwordValidator}
                    pattern="[A-Za-z]{3}"
                    maxLength="10"
                  />
                  {error && <Error>{error}</Error>}
                </PhoneInputWrapper>
              </div>
              <div>
                <Ptag
                  fontSize="18px"
                  fontWeight="700"
                  marginLeft="1rem"
                  marginBottom="1rem"
                >
                  Confirm Password
                </Ptag>
                <PhoneInputWrapper>
                  <PhoneInput
                    type="password"
                    // value={password}
                    onChange={passwordValidator2}
                    pattern="[A-Za-z]{3}"
                    maxLength="10"
                  />
                  {passwordError && <Error>{passwordError}</Error>}
                </PhoneInputWrapper>
              </div>
            </div>
            {/* <BaseTextArea name={"email_address"} />
            <BaseTextArea name={"Password"} /> */}
            <LargeButton label="Update" onClick={() => loginHandler()} />
          </div>
        </LoginContentWrapper>
      </LoginPageWrapper>
    </>
  );
};

export default ResetPassword;
